import { render, staticRenderFns } from "./DevDocManage.vue?vue&type=template&id=7fead3e0&scoped=true&"
import script from "./DevDocManage.vue?vue&type=script&lang=js&"
export * from "./DevDocManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fead3e0",
  null
  
)

export default component.exports